import { IoCheckmarkCircleOutline, IoClose } from "react-icons/io5";
import { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { Link, useNavigate } from "react-router-dom";

const SuccessModal = ({ setIsModalOpen, isModalOpen }) => {
  const [showLoader, setShowLoader] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate loading animation for 3 seconds
    const timer = setTimeout(() => setShowLoader(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Dialog
      open={isModalOpen}
      onClose={() => {
        setIsModalOpen(false);
        navigate("/");
      }}
      className="fixed inset-0 px-4 md:p-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50"
    >
      <Dialog.Panel className="bg-white p-6 rounded-lg shadow-lg w-[400px] text-center relative">
        {/* Close Button */}
        {/* <Link
          to={"/"}
          className="absolute  top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <IoClose size={22} />
        </Link> */}

        {/* Success Icon */}
        <IoCheckmarkCircleOutline
          className="text-green-500 mx-auto"
          size={50}
        />

        {/* Title */}
        <Dialog.Title className="text-xl font-semibold text-gray-900 mt-4">
          Thanks for sharing your preferences!
        </Dialog.Title>

        {/* Description */}
        <p className="text-gray-600 mt-2 text-sm px-4">
          Cooking up your perfect table match...
        </p>

        {/* Loader Animation */}
        {showLoader ? (
          <div className="flex justify-center my-3">
            <div className="w-6 h-6 border-4 border-gray-300 border-t-green-500 rounded-full animate-spin"></div>
          </div>
        ) : (
          <p className="text-gray-600 text-sm px-4">
            Your match is on the way—keep an eye on your inbox!
          </p>
        )}

        {/* Explore Button */}
        <button
          onClick={() => navigate("/")}
          className="mt-6 px-6 py-3 bg-gray-900 text-white rounded-md w-full"
        >
          Explore all tables
        </button>
      </Dialog.Panel>
    </Dialog>
  );
};

export default SuccessModal;
